<div class="card short-card shadow-lg notification-panel w-50">
  <div class="card-body">
    <div class="d-flex">
      <h4 class="m-0">
        @if (notificationInfo && notificationInfo.notificationCount > 0) {
          <span
            class="color-orange"
            >
            @if (notificationInfo.notificationCount === 1) {
              <span
                >Hai {{ notificationInfo.notificationCount }} nuovo messaggio</span
                >
              }
              @if (notificationInfo.notificationCount > 1) {
                <span
                  >Hai {{ notificationInfo.notificationCount }} nuovi messaggi</span
                  >
                }
              </span>
            }
            @if (notificationInfo.notificationCount === 0) {
              <span>Notifiche</span>
            }
          </h4>
          <div class="ms-auto pointer" (click)="closePanel()">
            <img src="/assets/images/icons/close.svg" />
          </div>
        </div>
        <hr />
        <div>
          @if (dataSet.length > 0) {
            <app-notification-list
              [dataSet]="dataSet"
              (read)="readNotification($event)"
            ></app-notification-list>
          }
          @if (dataSet && dataSet.length === 0) {
            <div class="text-center">
              Nessuna notifica presente
            </div>
          }
        </div>

        @if (dataSet) {
          <div
            class="row justify-content-between table-paginator no-gutters"
            >
            <div class="col-12 col-md-6">
              @if (pagination && dataSet && dataSet.length > 0) {
                <pwc-pagination
                  [page]="pagination.number + 1"
                  [pageSize]="pagination.size"
                  [collectionSize]="pagination.totalElements"
                  (pageChange)="onPageChange($event)"
                  [showCollectionSize]="false"
                  class="pagination-resp"
                ></pwc-pagination>
              }
            </div>
          </div>
        }
      </div>
    </div>
